module.exports = __webpack_public_path__ + "si.svg?fe78acc9a5e57c78ea07ea0a20602c44";